<!--  -->
<template>
  <div>
      <el-table ref="plxTable" :data="fileList" style="margin-top:10px;" max-height="500" show-overflow="ellipsis" highlight-current-row>
         <el-table-column label="附件类型" align="center" prop="userName">
              <template slot-scope="scope">
                <span>{{scope.row.docComments.split('-')[scope.row.docComments.split('-').length-1]}}</span>
              </template>
        </el-table-column>
        <el-table-column align="center" label="文件名称"   prop="documentName">
        <template slot-scope="scope">
            <el-button @click="onDownload(scope.row)" type="text" size="small">{{scope.row.documentName}}</el-button>
        </template>
        </el-table-column>
        <el-table-column label="文件描述" align="center" prop="docComments">
            <template slot-scope="scope">
              <span>{{scope.row.docComments.split('-'+scope.row.docComments.substring(scope.row.docComments.lastIndexOf('-')+1,scope.row.docComments.length))[0]  }}</span>
            </template>
        </el-table-column>
        <el-table-column label="上传人" align="center" prop="userName"></el-table-column>
        <el-table-column label="上传时间" align="center" prop="createDate"></el-table-column>
    </el-table>

  </div>
</template>

<script>
import { fileService } from "@/api/common/file-utils"

export default {
 props:['fileList'],
  data () {
    return {
    };
  },

  components: {},

  computed: {},

  methods: {
      onDownload(row){
      fileService.downloadFile(row).then((res) => { })
    },
  }
}

</script>
<style  scoped>
</style>